import React from 'react';
import { Button, Tooltip } from '@mantine/core';
import { FaRegArrowAltCircleDown } from "react-icons/fa";
import { notifications } from '@mantine/notifications';
import { baseUrl } from '../../Constants/constant';

interface SampleFileProps {
    type: string;
}

const SampleFile = ({ type }: SampleFileProps) => {
    const token = localStorage.getItem('token');
    const updatedUrl = baseUrl.replace("/api/", "");
    const [loading, setLoading] = React.useState(false);

    const sampleFileUrls: Record<string, string> = {
        'rawmaterialSubType': `/uploads/sample/raw-material-sub-type.xlsx`,
        'vertical': `/uploads/sample/vertical.xlsx`,
        'category': `/uploads/sample/category.xlsx`,
        'transport': `/uploads/sample/transport.xlsx`,
        'package-box': `/uploads/sample/sample-box.xlsx`,
        'pallet': `/uploads/sample/sample-pallet.xlsx`,
        'raw-material': `/uploads/sample/material.xlsx`,
        'disposal': `/uploads/sample/sample-disposal.xlsx`,
        'process': `/uploads/sample/sample-process.xlsx`,
    };

    const showNotification = (type: 'success' | 'error', title = "message") => {
        notifications.show({
            title,
            message: type === 'success'
                ? "Download successfully."
                : "Something went wrong. Please try again.",
            color: type === 'success' ? "green" : "red",
        });
    };

    const handleButtonClick = async () => {
        setLoading(true);
        try {
            const fileUrl = sampleFileUrls[type];
            if (!fileUrl) {
                showNotification('error', 'Invalid file type');
                return;
            }

            const response = await fetch(`${updatedUrl}${fileUrl}`, {
                method: 'GET',
                headers: {
                    token: token || '',
                    'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            // Check if the response is actually an Excel file
            const contentType = response.headers.get('content-type');
            if (!contentType || !contentType.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')) {
                console.error('Wrong content type:', contentType);
                throw new Error('Received incorrect file format from server');
            }

            const blob = await response.blob();
            const downloadUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.download = `sample-${type}.xlsx`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(downloadUrl);
            showNotification('success');
        } catch (error) {
            console.error('Download error:', error);
            showNotification('error', 'Download failed');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Tooltip label="Download Sample File (csv, xlsx)" color="#404040">
            <Button
                variant="filled"
                loading={loading}
                loaderProps={{ type: 'oval' }}
                styles={{
                    root: {
                        backgroundColor: '#404040',
                        '&:hover': {
                            backgroundColor: '#505050'
                        }
                    }
                }}
                onClick={handleButtonClick}
            >
                <FaRegArrowAltCircleDown size={25} />
            </Button>
        </Tooltip>
    );
};

export default SampleFile;